/**
 * /moodboard — project-grounded inspiration surface.
 *
 * Wraps the existing MoodBoard component (already typed-graph driven —
 * pulls Intent / Style / Room / Material nodes from the active project)
 * in a route header matching the rest of the cockpit.
 *
 * Referenced from the Integrations Topology view ("Moodboard · style
 * cohesion" tile); this route makes that wire live.
 */
import { Sparkles } from "lucide-react";
import { MoodBoard } from "../components/inspiration/MoodBoard";
import { useActiveProjectGraph } from "../lib/useActiveProjectGraph";

export default function Moodboard(): JSX.Element {
  const { graph } = useActiveProjectGraph();
  return (
    <div className="max-w-[1280px] mx-auto px-4 sm:px-8 py-10 space-y-5">
      <header className="rounded-3xl border border-border/70 bg-gradient-to-br from-foyr/10 via-cream to-mulberry/5 px-6 py-7 overflow-hidden">
        <div className="eyebrow inline-flex items-center gap-1.5">
          <Sparkles className="w-3 h-3" /> Moodboard
        </div>
        <h1 className="font-newyork text-[34px] mt-1 text-ink-950 leading-[1.04] tracking-tight">
          {graph.projectName} · style cohesion
        </h1>
        <p className="text-[13px] text-ink-700 mt-2 max-w-2xl leading-relaxed">
          The inspiration deck for this project — Intent, Style, Room palettes, and Material
          stories pulled directly from the typed project graph. Tags style for the agent rail
          (the same suggestion engine that watches /design).
        </p>
      </header>
      <MoodBoard />
    </div>
  );
}
